import React from 'react';
import classnames from 'classnames';
import superSpeedIcon from 'assets/svg/super-speed-widget.svg';
import classes from './super-speed-widget.scss';
export const SuperSpeedWidget = ({
  className,
  onClick
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames(classes.widget, className)
}, /*#__PURE__*/React.createElement("div", {
  className: classes.iconWrapper
}, /*#__PURE__*/React.createElement("img", {
  src: superSpeedIcon
})), /*#__PURE__*/React.createElement("p", {
  className: classes.title
}, "Get it Faster with Super Speed"), /*#__PURE__*/React.createElement("div", {
  className: classes.divider
}), /*#__PURE__*/React.createElement("p", {
  className: classes.text
}, "In a rush? Check out our selection of products that can be produced super fast!", ' ', /*#__PURE__*/React.createElement("span", {
  className: classes.link,
  onClick: onClick
}, "Shop Super Speed")));